import { Injectable } from '@angular/core';
import { CardBackgroundViewModel } from '../../card-background-view-model';

@Injectable()
export class GlassHouseShelfTalkerPostCardBackgroundViewModel extends CardBackgroundViewModel {}
